import { acpDebitCardTransfersStates } from './states';

export default (appModule) => {
  appModule.config(acpDebitCardTransfersStates);
};
